import { render, staticRenderFns } from "./fulfillment-detail-leads.vue?vue&type=template&id=2ea82bd2&scoped=true"
import script from "./fulfillment-detail-leads.vue?vue&type=script&lang=js"
export * from "./fulfillment-detail-leads.vue?vue&type=script&lang=js"
import style0 from "./fulfillment-detail-leads.vue?vue&type=style&index=0&id=2ea82bd2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ea82bd2",
  null
  
)

export default component.exports